import React, { useState, useEffect, useMemo, useRef, useCallback, useImperativeHandle } from "react";
import axios from 'util/axios';
import {dateToDateFormat, getURLParam} from "util";
import {faAngleDown, faAngleUp, faPenClip, faUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SearchBox from "../../Review/Component/SearchBox";
import RefreshBtnV2 from "./RefreshBtnV2";
import ReviewStartBtnV2 from "./ReviewStartBtnV2";
import ReviewComponentV2 from "util/component/ReviewV2";
import CompareBtn from "./Compare";
import ReviewRefreshBtnV2 from "./ReviewRefreshBtnV2";

const clickAction = (uniqueCode, celNm, type, action) => {
    let find;
    let child;

    if (celNm.toString().match(/remark/gi)) {
        uniqueCode = uniqueCode.split(",");
        find = document.querySelectorAll(`*[data-cellnm=${celNm}]`).forEach((e) => {
            if(e.dataset.uniquecode.includes(uniqueCode[0])===true){
               child = e;
            }
        });
    // } else if (type.match(/(H|C|F|D|E|S)/)) {
    } else if (type.match(/(HEADER|COMMON|FOOTER|DES|H|C|F|D|E)/)) {
        child = document.querySelector(`*[data-uniquecode=${uniqueCode}]`);
    } else {
        find = document.querySelector(`*[data-uniquecode=${uniqueCode}]`);
        child = find?.querySelector(`*[data-cellnm=\"${celNm}\"]`);
    }

    if (action) {
        window.history.replaceState(
            null,
            "",
            `/review?geneCode=${action.geneCode}&revision=${action.revision}&tempYn=${action.tempYn}`
        );
    }
    child?.click();
};

const UnconfirmedListV2 = (props) => {
    const [List, SetList] = useState([]);
    const [Show, SetShow] = useState(false);
    const containerRef = useRef(null);
    const oneClick = useRef(1);
    const [Selected, SetSelected] = useState(null);
    const [filter, setFilter] = useState(false);
    const [geneCd, setGeneCd] = useState(null);

    const getData = useCallback(async () => {
        const doc = props.doc.doc;
        if (!doc) {
            return;
        }
        const postData = doc?.sheetList?.map((e) => {
            return { sheetCode: e.master?.sheetCode, revision: e.master?.revision };
        });

        const docInfo = doc.desc[0];

        const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/retrieveCompleteListAll", [
            { sheetCode: docInfo.descCode, revision: docInfo.revision },
            ...postData,
        ]);
        const data = response.data.data;
        SetList(data?.result || []);
        const URL_PARAM = getURLParam();
        if (URL_PARAM.uniqueCode) {
            const { geneCode, revision, tempYn, uniqueCode, celNm } = URL_PARAM;
            let type = "";
            if (celNm === "Description Review Data") {
                type = "DES";
            }
            // 편의기능
            if (oneClick.current > 0) {
                setTimeout(() => {
                    clickAction(uniqueCode, celNm, type, { geneCode, revision, tempYn });
                }, 500);
                oneClick.current--;
            }
        }
    }, [props.doc]);

    const HandleClickEvent = useCallback(
        (e) => {

            // if(props.doc.revInfo.revision === "0" || props.doc.revInfo.revision === 0 || (props.doc.revInfo.revision === 1 && props.doc.revInfo.tempYn ==="N")){
            //     containerRef.current.querySelectorAll(".compare-div button").forEach((f) => { f.remove() });
            // }

            if (e.target.closest(".unconfirmlist-wrapperV2-bar")) {
                SetShow(!Show);
            }
        },
        [Show]
    );

    useEffect(() => {
        getData();
        containerRef?.current?.addEventListener("click", HandleClickEvent);
        return () => {
            containerRef?.current?.removeEventListener("click", HandleClickEvent);
        };

    }, [HandleClickEvent, getData, props]);

    const mainRender = useMemo(() => {
        let render;
        if (List.length > 0)
            render = [...List].map((rowData, index) => {
                return (
                    <tr
                        key={`unConfirmedListV2${index}`}
                        onClick={() => clickAction(rowData.uniqueCode, rowData.celNm, rowData.sheetType)}
                    >
                        {rowData.sheetType.match(/(HEADER|COMMON|FOOTER)/) ? (
                            <>
                                <td colSpan="2">{rowData.sheetType}</td>
                                <td title={rowData.paraNm}>{rowData.paraNm}</td>
                            </>
                        ) : (
                            <>
                                <td className={"text-center"}>{rowData.mbrNo}</td>
                                <td title={rowData.description}>{rowData.description}</td>
                                <td title={rowData.paraNm}>{rowData.paraNm}</td>
                            </>
                        )}
                    </tr>
                );
            });
        else
            render = (
                <tr>
                    <td colSpan="3">No List</td>
                </tr>
            );
        return render;
    }, [List]);

    const filterAction = (search,prev,next,chk,external) => {
        let checked;
        let userNm;
        let searchText;
        let filter;

        if (chk===true){filter = props.doc.revAllData.filter((f) => f.cmptType === "R")} else filter = props.doc.revAllData

        if (external===true){filter = filter.filter((f) => f.externalViewYn === "Y")} else filter = filter

        if (prev && next) {
            prev = dateToDateFormat(prev, true).replaceAll(".", "")
            next = dateToDateFormat(next, true).replaceAll(".", "")

            filter = filter.filter((f) =>
                prev <= f.createDt.substring(0,10).replaceAll("-", "")
                && next >= f.createDt.substring(0,10).replaceAll("-", "")
            )
        }

        if(search.user===null){ userNm="" } else userNm = search.user.label
        if(search.search===null || search.search.target === undefined){searchText=""} else searchText = search.search.target.value

        if(userNm===undefined || userNm==="") {} else filter = filter.filter((i) => i.userNm === userNm)
        if(searchText===undefined || searchText==="") {} else filter = filter.filter((j) => { return j.content.toLowerCase().indexOf(searchText.toLowerCase()) > -1; } )

        setFilter(filter)
    };

    const compare = () => {
        window.open("/ReviewCompare" + window.location.search, "_blank");
    }
    

    return (
        <div className={`unconfirmlist-wrapperV2 ${Show}`} ref={containerRef}>
            {/*<div className={"show-btn"}>Unconfirmed</div>*/}
            <div className={"unconfirmlist-wrapperV2-bar"}>
                <div className={"handle"}>
                    <div className={"inner"}>
                        <div>Comment</div>
                        <div style={{textAlign: "center"}}>List</div>
                        {/*<FontAwesomeIcon icon={Show ? faAngleUp : faAngleDown}/>*/}
                    </div>
                </div>
            </div>
            <div className={"content"}>
                <SearchBox style={{position: "static", width: "max-content", zIndex: "100"}} comment={props} filterAction={filterAction}/>
                <ReviewComponentV2 comment={props} refresh={props.refresh} clickAction={clickAction} rowData={List} close={SetSelected} filterAction={filter} templateOwners={props.templateOwners} pcsOwnerId ={props.pcsOwnerId}/>
                {props.doc.revInfo.revision === "0" || props.doc.revInfo.revision === 0 || (props.doc.revInfo.revision === 1 && props.doc.revInfo.tempYn === "N") ? (
                    <div className={"contentV2"}>
                        {/*<RefreshBtnV2 refresh={props.refresh}/>*/}
                        <ReviewRefreshBtnV2 refresh={props.refresh}/>
                        {/*<CompareBtn compare={compare}/>*/}
                    </div>
                ) : <div className={"contentV2"}>
                        <RefreshBtnV2 refresh={props.refresh}/>
                        {/*<ReviewRefreshBtnV2 refresh={props.refresh}/>*/}
                        <CompareBtn compare={compare}/>
                    </div>
                }
            </div>
        </div>
    );
};

export default UnconfirmedListV2;
